<div>
    <h2>{{'disenyo-etiquetas.titulo' | translate}}</h2>
    <section class="filters-framed" *ngIf="filtersVisible">
        <form [formGroup]="filtersForm" [ngClass]="{'show-error': showError}">
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'disenyo-etiquetas.filters.nombreDisenyo' | translate}}</label>
                <input type="text" formControlName="nombre">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'disenyo-etiquetas.filters.tipoConfeccion.titulo' | translate}}</label>
                <app-filterable-list [itemsList]="tiposConfeccion" [selectedItem]="filtersForm.get('tipoConfeccion')" [placeHolder]="false"></app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'global.fecha.inicio' | translate}}</label>
                <input [matDatepicker]="fechaInicio" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaInicio" (click)="fechaInicio.open()">
                <mat-datepicker #fechaInicio></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'global.fecha.fin' | translate}}</label>
                <input [matDatepicker]="fechaFin" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaFin" (click)="fechaFin.open()">
                <mat-datepicker #fechaFin></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="radio-group no-margin-left">
                <input type="radio" id="insercion" value="false" formControlName="dateType">
                <label for="insercion">{{'global.fecha.insercion' | translate}}</label>
                <input type="radio" id="actualizacion" value="true" formControlName="dateType">
                <label for="actualizacion">{{'global.fecha.actualizacion' | translate}}</label>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                </div>
        </form>
    </section>
    <section class="filters-buttons">
        <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.abrir' | translate}}">
            <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
            <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
            [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
            title="{{'global.filtros.limpiar' | translate}}">
            <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
            <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
    </section>
    <div class="table-wrapper">
        <div class="table-container">
            <table>
                <thead>
                    <tr>
                        <th class="id sortable" (click)="toOrderBy('x=> x.id', 2)" style="padding-left: .5rem;">
                          {{'disenyo-etiquetas.table.id' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.id')"></i></div>
                        </th>
                        <th class="string sortable sortable-biggest" (click)="toOrderBy('x=> x.des', 3)">
                          {{'disenyo-etiquetas.table.nombre' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.des')"></i></div>
                        </th>
                        <th class="string sortable" (click)="toOrderBy('x=> x.TipoConfeccion.des', 4)">
                          {{'disenyo-etiquetas.table.tipoConfeccion' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.TipoConfeccion.des')"></i></div>
                        </th>
                        <th class="date sortable" (click)="toOrderBy('x=> x.fechaIns', 5)">
                          {{'global.fecha.insercionShort' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.fechaIns')"></i></div>
                        </th>
                        <th class="date sortable" (click)="toOrderBy('x=> x.fechaUpd', 6)">
                          {{'global.fecha.actualizacionShort' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.fechaUpd')"></i></div>
                        </th>
                        <th class="action"><i class="fas fa-plus" (click)="create()" title="{{'disenyo-etiquetas.tituloNew' | translate}}"></i></th>
                    </tr>
                </thead>
                <tbody *ngFor="let etiqueta of etiquetas; trackBy: trackByEtiquetaId">
                    <tr>
                        <td class="id" style="padding-left: .5rem;">{{etiqueta.id}}</td>
                        <td class="string-longest">{{etiqueta.des}}</td>
                        <td class="string">{{etiqueta.desTipoConfeccion}}</td>
                        <td class="date">{{etiqueta.fechaIns | date: 'shortDate' : undefined : defaultLanguage}}</td>
                        <td class="date">{{etiqueta.fechaUpd | date: 'shortDate' : undefined : defaultLanguage}}</td>
                        <td class="multi-actions">
                            <i class="fa solid fa-upload" (click)="openImagen(etiqueta)" title="{{'titles.imagenAsociada' | translate}}"></i>
                            <i class="fas fa-pencil-alt" (click)="update(etiqueta)" title="{{'titles.editar' | translate}}"></i>
                            <i class="far fa-trash-alt" (click)="askDelete(etiqueta)"
                                [ngClass]="{'disabled': etiqueta.registroEnUso}" title="{{'titles.eliminar' | translate}}"></i>
                        </td>
                    </tr>
                </tbody>
                <tfoot *ngIf="!etiquetas || (etiquetas && etiquetas.length < 1)">
                    <tr>
                        <td colspan="5">
                            {{'global.noContent' | translate}}
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
    <app-paginator *ngIf="etiquetas && etiquetas.length > 0" [itemsPerPage]="itemsPerPage" [currentPage]="currentPage + 1"
        [totalItems]="totalItems" [visiblePages]="visiblePages" (pageChange)="pageChange($event)"
        (itemsPerPageChange)="itemsPerPageChange($event)"></app-paginator>
    <app-toast *ngIf="(showError) && mensajes" [messages]="mensajes" (closed)="showError=$event">
    </app-toast>
</div>
<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
        <header>
            <h4>{{ 'global.eliminar.descripcion' | translate }}</h4>
        </header>
        <content>
            <p>{{ 'global.eliminar.confirmacion' | translate }}</p>
        </content>
        <footer>
            <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
            <button (click)="delete()">{{'global.confirmar' | translate}}</button>
        </footer>
    </div>
</div>
<div class="modal" *ngIf="newEditModal">
    <div class="modal-content">
        <header>
            <h4>{{disenyoEtiquetaId ? ('disenyo-etiquetas.tituloEdit' | translate) : ('disenyo-etiquetas.tituloNew' | translate)}}
            </h4>
        </header>
        <app-disenyo-etq-new-edit [disenyoEtiquetaId]="disenyoEtiquetaId" (refresh)="refresh($event)" (mensaje)="pushMessage($event)">
        </app-disenyo-etq-new-edit>
    </div>
</div>
<div class="modal" *ngIf="uploadModal">
    <div class="modal-content">
        <header>
            <h4>{{'disenyo-etiquetas.tituloAsociar' | translate}}</h4>
        </header>
        <app-upload-imagen [disenyoEtiquetaId]="disenyoEtiquetaId" [imagen]="imagen" [filename]="filename"
            (refresh)="refresh($event)" (refreshReferencia)="refreshReferencia($event)" (mensaje)="pushMessage($event)">
        </app-upload-imagen>
    </div>
</div>
